import PortalVue from 'portal-vue'

export default PortalVue
